import React from 'react';

interface AgentAvatarProps {
  avatarUrl?: string;
  avatarGradient?: string;
  name: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  square?: boolean;
}

const SIZE_MAP: Record<NonNullable<AgentAvatarProps['size']>, string> = {
  sm: 'w-10 h-10 text-sm',
  md: 'w-14 h-14 text-base',
  lg: 'w-20 h-20 text-2xl',
  xl: 'w-28 h-28 text-4xl',
};

const FALLBACK_GRADIENT = 'linear-gradient(135deg, #00C805 0%, #00922e 60%, #00230c 100%)';

/**
 * Renders an agent's avatar: a real image if avatarUrl is set, otherwise
 * a gradient blob using avatarGradient (or a brand-green fallback gradient)
 * with the agent's initial.
 */
export const AgentAvatar: React.FC<AgentAvatarProps> = ({
  avatarUrl,
  avatarGradient,
  name,
  size = 'md',
  className = '',
  square = false,
}) => {
  const sizeClass = SIZE_MAP[size];
  const shapeClass = square ? 'rounded-2xl' : 'rounded-full';

  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt={name}
        className={`${sizeClass} ${shapeClass} object-cover shrink-0 ${className}`}
      />
    );
  }

  return (
    <div
      className={`${sizeClass} ${shapeClass} shrink-0 flex items-center justify-center font-bold text-white shadow-inner ${className}`}
      style={{ background: avatarGradient || FALLBACK_GRADIENT }}
    >
      {name?.charAt(0)?.toUpperCase() || '?'}
    </div>
  );
};

export default AgentAvatar;
